import styled from 'styled-components';

export const Wrapper = styled.footer`
  background-color: #d2cbc8;
  padding: 50px 0;
`;

export const Content = styled.div`
  display: flex;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const Menu = styled.div`
  flex-basis: calc(33% - 50px);
  width: calc(33% - 50px);
  margin-left: 50px;

  &:first-child {
    margin-left: 0;
  }
  &:first-child{
  @media (max-width: 768px){
    margin-left: 10px;
  }
  }

  @media (max-width: 768px){
    flex-basis: calc(100%);
    width: calc(100%);
    margin-left: 10px;
  }

  h3 {
    border-bottom: 1px solid #9b9696;
    padding-bottom: 25px;
    font-weight: bold;
    height: 60px;
    @media (max-width: 992px){
      font-size: 16px;
      padding-bottom: 10px;
      height: 50px;
    }
    @media (max-width: 768px){
      height: 30px;
    }
    @media (max-width: 480px){
      font-size: 14px;
    }
  }

  ul {
    margin-top: 25px;
    font-size: 12px;

  @media (max-width: 768px){
    margin-top: 0;
    margin-bottom: 20px;
  }
}

  li {
    padding: 15px 10px 5px 0;
    line-height: 1.5;

    a {
      border-bottom: 1px solid #9b9696;
      padding-bottom: 2px;

      @media (max-width: 992px) {
        font-size: 12px;
        padding-bottom: 0;
      }


      &:hover {
        border-color: #000;
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/system/footer/components.js